import { render } from "./app.vue?vue&type=template&id=57258226"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/layouts/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57258226"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57258226', __exports__)) {
    console.log('reload')
    api.reload('57258226', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=57258226", () => {
    console.log('re-render')
    api.rerender('57258226', render)
  })

}


export default __exports__